export default __webpack_public_path__ + "static/media/hero_videodemo.7e658367.mp4";